import { ElementRef } from '@angular/core';
import { OnInit } from '@angular/core';
import { Directive } from '@angular/core';
import { SessionService } from '../session-service.service';

@Directive({
  selector: '[appConfigSettingsBackground]'
})
export class ConfigSettingsBackgroundDirective implements OnInit {

  constructor(private elementRef: ElementRef, private sessionService: SessionService) { }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.backgroundColor = this.sessionService.getConfigSettingsDto().backgroundColor;
    this.elementRef.nativeElement.style.color = this.sessionService.getConfigSettingsDto().backgroundTextColor;
  }
}
